<!-- eslint-disable vue/no-mutating-props -->
<script lang="ts">
import { get, useOnlineStore } from "../../../../store"

export default {
    name: "AutocompleteFilter",
    props: {
        translationName: { type: String, required: true },
        filter: { type: Object, required: true },
    },
    emits: ["updateFilters", "clearFilter", "updateFilterState"],
    data() {
        return {
            page: 1,
            search: null,
            focused: false,
            loading: false,
            autocompleteUrlChoices: [],
            autocompleteData: [],
            autocompleteInit: true,
            useOnlineStore,
        }
    },
    mounted() {
        this.initSelectedAtStartText()
        this.initUrlQuery()
    },
    methods: {
        async initSelectedAtStartText() {
            if (this.filter.initial_value) {
                this.$emit("updateFilterState", { ...this.filter, init: false })
                const defaultValue = Array.isArray(this.filter.initial_value) ? this.filter.initial_value.map(item => `${item}`) : this.filter.initial_value

                // Si un filtre avec une valeur par défaut est aussi dans l'url, ne pas lancer la récupération de la valeur par defaut, et laisser initUrlQuery passer l'initialisation (init) à true
                const urlKeys = Object.keys(this.$route.query) // ['type_hydrant']
                const isFilterInUrl = urlKeys.find(key => key === this.filter.name)
                if (!isFilterInUrl) {
                    // ---------

                    // GET TEXT VALUE FROM URL DATA (usually id)
                    if (useOnlineStore().online) {
                        this.$api.setRequest({
                            url: `${this.filter.autocomplete_url}${`&filter[k]=${defaultValue}`}`,
                            method: "GET",
                        }).then((res) => {
                            this.autocompleteData = res.data // SAVE DATA TEXT
                            this.$emit("updateFilterState", { ...this.filter, init: true, value: defaultValue })
                        })
                    }
                    else if (window && window.indexedDB) {
                        const url = this.filter.autocomplete_url.split("?")[0]
                        // eslint-disable-next-line eqeqeq
                        this.autocompleteData = (await get(`${url}-data`)).filter(n => n.k == defaultValue) // SAVE DATA TEXT
                        this.$emit("updateFilterState", { ...this.filter, init: true, value: defaultValue })
                    }
                }
            }
        },
        initUrlQuery() {
            if (!this.$route.path.includes("formulaire")) {
                const defaultKeys = Object.keys(this.$route.query) // ['type_hydrant']
                defaultKeys.forEach(async (key) => {
                    if (this.filter.name === key) {
                        this.$emit("updateFilterState", { ...this.filter, init: false })
                        const values = this.$route.query[key]

                        if (useOnlineStore().online) {
                            // GET TEXT VALUE FROM URL DATA (usually id)
                            this.$api.setRequest({
                                url: `${this.filter.autocomplete_url}${`&filter[k]=${values}`}`,
                                method: "GET",
                            }).then((res) => {
                                this.autocompleteData = res.data // SAVE DATA TEXT
                                const value = res.data.map(data => data.k)
                                // this.updateFilters(value) // ADD VALUES (id) IN FILTER
                                this.$emit("updateFilterState", { ...this.filter, init: true, value })
                            })
                        }
                        else if (window && window.indexedDB) {
                            // Probably this won't work
                            const url = this.filter.autocomplete_url.spilt("?")[0]
                            // eslint-disable-next-line eqeqeq
                            const data = (await get(`${url}-data`)).filter(n => n.k == values)
                            const value = data.map(data => data.k)
                            this.autocompleteData = data // SAVE DATA TEXT
                            this.$emit("updateFilterState", { ...this.filter, init: true, value })
                        }
                    }
                })
            }
        },
        endIntersect(isIntersecting) {
            if (isIntersecting && !this.loading && !this.filter.init && this.autocompleteUrlChoices.length) {
                this.page += 1
                this.getItems()
            }
        },
        unfocused(event) {
            if (!event) { // WHEN UNFOCUSED
                this.page = 1
                this.autocompleteUrlChoices = [] // RESET CHOICES TO AVOID HAVING SEARCH VALUES + BASIC VALUES. GETITEMS LAUNCH ON CLICK
            }
            this.focused = event // NEEDED FOR SEARCH FUNCTION TO KNOW IF WE NEED TO UPDATE DATA OR NOT
        },
        updateSearch(search: string | null = null) {
            this.search = search
            this.page = 1
            if (this.focused) {
                this.getItems(true)
            }
        },
        async getItems(searchUpdate: boolean | false) {
            const pagination = `&page[number]=${this.page}` // AVOID PAGINATION ON SEARCH BECAUSE SIDE EFFECTS. CAN BE FIX LATER
            if (useOnlineStore().online) {
                this.loading = true
                const res = await this.$api.setRequest({
                    url: `${this.filter.autocomplete_url}${this.search ? `&search=${this.search}` : ""}${pagination}`, //  ${query ? `&${query}` : ''}
                    method: "GET",
                })

                if (res) {
                    // IF SEARCH CHANGED, UPDATE DATA, ELSE ADD DATA
                    if (searchUpdate) {
                        this.autocompleteUrlChoices = res.data
                    }
                    else {
                        res.data.forEach((data) => {
                            if (!this.autocompleteUrlChoices.some(choice => choice.k === data.k)) {
                                this.autocompleteUrlChoices = [...this.autocompleteUrlChoices, data]
                            }
                        })
                    }
                    // this.autocompleteUrlChoices = searchUpdate ? res.data : [...this.autocompleteUrlChoices, ...res.data]

                    // IF SELECTED VALUES ARE NOT IN NEW CHOICES : ADD THEM IN CHOICES
                    this.autocompleteData.forEach((data) => {
                        const found = this.autocompleteUrlChoices.find(choice => choice.k === data.k)
                        if (!found) {
                            this.autocompleteUrlChoices.push(data)
                        }
                    })
                }
                this.loading = false
                return res
            }
            // Offline mode
            if (this.filter.autocomplete_url) {
                const url = this.filter.autocomplete_url.split("?")[0]
                const queryString = this.filter.autocomplete_url.split("?")[1] || ""
                const urlParams = new URLSearchParams(queryString)

                let data = []
                if (await get(`${url}-list`)) {
                    // eslint-disable-next-line eqeqeq
                    data = (await get(`${url}-list`)).filter(d => !this.search || d.v == this.search || d.name == this.search || d.k == this.search)
                }

                const limitToId = urlParams.get("filter[limit_to_accessible_for]")
                if (limitToId) {
                    const parentId = Number.parseInt(limitToId)
                    const allCommunes = await get(`${url}-list`) || []
                    const parentCommune = allCommunes.find(d => d.id === parentId)

                    if (parentCommune) {
                        const allowedIds = [parentId]
                        if (parentCommune.accessible_communes) {
                            parentCommune.accessible_communes.forEach(ac => allowedIds.push(ac.id))
                        }
                        data = data.filter(d => allowedIds.includes(d.id))
                    }
                    else {
                        data = data.filter(d => d.id === parentId)
                    }
                }

                if (searchUpdate) {
                    this.autocompleteUrlChoices = data
                }
                else {
                    data.forEach((data) => {
                        if (!this.autocompleteUrlChoices.some(choice => choice.k === data.k)) {
                            this.autocompleteUrlChoices = [...this.autocompleteUrlChoices, data]
                        }
                    })
                }

                this.autocompleteData.forEach((data) => {
                    const found = this.autocompleteUrlChoices.find(choice => choice.k === data.k)
                    if (!found) {
                        this.autocompleteUrlChoices.push(data)
                    }
                })
            }
        },
        updateFilters(value) {
            // autocomplete value doesn't exist anymore when data is updated by search. we save data in another object so we can find it later to show it
            if (value?.length) {
                if (this.filter.multiple) {
                    this.autocompleteData = value.map((id) => {
                        const currentChoice = this.autocompleteData.find(choice => choice.k === id)
                        const foundChoice = this.autocompleteUrlChoices.find(choice => choice.k === id)
                        return foundChoice || currentChoice
                    })
                }
                else {
                    const currentChoice = this.autocompleteData.find(choice => choice.k === value)
                    const foundChoice = this.autocompleteUrlChoices.find(choice => choice.k === value)
                    this.autocompleteData = [foundChoice || currentChoice]
                }
            }
            else {
                this.autocompleteData = []
            }
            this.$emit("updateFilters", value)
        },
    },
}
</script>

<template>
    <!--    eslint-disable vue/no-mutating-props -->
    <v-autocomplete
        v-model="filter.value"
        :label="$translate(`${translationName}.${filter.name}`)"
        :aria-label="$translate(`${translationName}.${filter.name}`)"
        :multiple="filter.multiple"
        :clearable="!filter.multiple"
        :items="autocompleteUrlChoices"
        item-title="v"
        item-value="k"
        variant="solo"
        :loading="loading"
        :open-on-clear="false"
        :no-data-text="loading ? '' : 'Aucun choix disponible'"
        @click="getItems(false)"
        @update:search="event => updateSearch(event)"
        @update:model-value="updateFilters($event)"
        @update:focused="unfocused($event)"
    >
        <!-- eslint-enable -->
        <template #selection="{ item, index }">
            <span v-if="index < 2">
                <v-chip
                    v-if="filter.multiple"
                    label
                    closable
                    size="x-small"
                    :variant="$config.public.chips_variant || 'tonal'"
                    :color="$getColor(`${translationName}.${filter.name}.${item.value}`)"
                    @click:close="$emit('clearFilter', item)"
                >
                    {{ autocompleteData.find(f => f.k === item.value)?.v }}
                </v-chip>
                <template v-else>
                    {{ autocompleteData.find(f => f.k === item.value)?.v }}
                </template>
            </span>
            <span
                v-if="index === 2"
                class="text-grey text-caption align-self-center"
            >
                (+{{ filter.value.length - 2 }} autre{{ filter.value.length > 3 ? 's' : '' }})
            </span>
        </template>
        <template #append-item>
            <div v-intersect="endIntersect" />
        </template>
    </v-autocomplete>
</template>
